/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const NotificationState = {
    Created: 1,
    Processing: 2,
    Failed: 3,
    Finished: 4
} as const;
export type NotificationState = typeof NotificationState[keyof typeof NotificationState];

